module.exports = [
  require('./erf')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/special/index.js
// module id = 1392
// module chunks = 0